import React from 'react';

export const PlusIconDefault: React.FC<sharedComponents.SvgIcon> = ({ className, width = 28, height = 28 }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={`${width}px`}
    height={`${height}px`}
    viewBox="0 0 28 28"
    fill="none"
  >
    <path d="M14 1C21.2 1 27 6.8 27 14C27 21.2 21.2 27 14 27C6.8 27 1 21.2 1 14C1 6.8 6.8 1 14 1ZM14 0C6.3 0 0 6.3 0 14C0 21.7 6.3 28 14 28C21.7 28 28 21.7 28 14C28 6.3 21.7 0 14 0Z" fill="#5514B4" />
    <path fillRule="evenodd" clipRule="evenodd" d="M14 8.09998C14.2761 8.09998 14.5 8.32383 14.5 8.59998V19.4C14.5 19.6761 14.2761 19.9 14 19.9C13.7239 19.9 13.5 19.6761 13.5 19.4V8.59998C13.5 8.32383 13.7239 8.09998 14 8.09998Z" fill="#5514B4" />
    <path d="M14 1C21.2 1 27 6.8 27 14C27 21.2 21.2 27 14 27C6.8 27 1 21.2 1 14C1 6.8 6.8 1 14 1ZM14 0C6.3 0 0 6.3 0 14C0 21.7 6.3 28 14 28C21.7 28 28 21.7 28 14C28 6.3 21.7 0 14 0Z" fill="#5514B4" />
    <path fillRule="evenodd" clipRule="evenodd" d="M8.1001 14C8.1001 13.7239 8.32396 13.5 8.6001 13.5H19.4001C19.6762 13.5 19.9001 13.7239 19.9001 14C19.9001 14.2761 19.6762 14.5 19.4001 14.5H8.6001C8.32396 14.5 8.1001 14.2761 8.1001 14Z" fill="#5514B4" />
  </svg>
);
